// Simple feature flag for premium features
// Set to false to completely disable premium offering
export const FEATURES = {
    PREMIUM_ENABLED: true, // Set to false to turn off premium
    POLAR_ENABLED: true, // Set to false during development/testing
    TRIALS_ENABLED: true, // Enable free trials for Plus features
} as const;

export function shouldShowUpgradePrompts(): boolean {
    return FEATURES.PREMIUM_ENABLED && FEATURES.POLAR_ENABLED;
}

export function shouldShowTrialPrompts(): boolean {
    return FEATURES.PREMIUM_ENABLED && FEATURES.TRIALS_ENABLED;
}
